/**
 * Copia texto para a área de transferência com fallback para
 * iOS/Safari, HTTP e contextos sem Clipboard API (iframe).
 */
export async function copiarTexto(texto: string): Promise<void> {
  const valor = String(texto ?? '')

  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(valor)
      return
    } catch {
      // Fallback abaixo (iOS, permissão negada, iframe sem clipboard-write)
    }
  }

  copiarComExecCommand(valor)
}

function copiarComExecCommand(valor: string): void {
  const area = document.createElement('textarea')
  area.value = valor
  area.setAttribute('readonly', '')
  area.setAttribute('aria-hidden', 'true')
  area.style.position = 'fixed'
  area.style.top = '0'
  area.style.left = '0'
  area.style.width = '1px'
  area.style.height = '1px'
  area.style.padding = '0'
  area.style.margin = '0'
  area.style.border = 'none'
  area.style.outline = 'none'
  area.style.boxShadow = 'none'
  area.style.background = 'transparent'
  area.style.opacity = '0'
  area.style.zIndex = '-1'

  document.body.appendChild(area)
  area.focus()
  area.select()
  area.setSelectionRange(0, area.value.length)

  const selecao = window.getSelection()
  if (selecao) {
    selecao.removeAllRanges()
    const range = document.createRange()
    range.selectNodeContents(area)
    selecao.addRange(range)
    area.setSelectionRange(0, area.value.length)
  }

  const ok = document.execCommand('copy')
  document.body.removeChild(area)

  if (!ok) {
    throw new Error('Falha ao copiar')
  }
}
